export const GET_INTERNSHIPS = "GET_INTERNSHIPS"
export const GET_INTERNSHIPS_FAIL = "GET_INTERNSHIPS_FAIL"
export const GET_INTERNSHIPS_SUCCESS = "GET_INTERNSHIPS_SUCCESS"

export const ADD_NEW_INTERNSHIP = "ADD_NEW_INTERNSHIP"
export const ADD_INTERNSHIP_SUCCESS = "ADD_INTERNSHIP_SUCCESS"
export const ADD_INTERNSHIP_FAIL = "ADD_INTERNSHIP_FAIL"

export const UPDATE_INTERNSHIP = "UPDATE_INTERNSHIP"
export const UPDATE_INTERNSHIP_SUCCESS = "UPDATE_INTERNSHIP_SUCCESS"
export const UPDATE_INTERNSHIP_FAIL = "UPDATE_INTERNSHIP_FAIL"

export const DELETE_INTERNSHIP = "DELETE_INTERNSHIP"
export const DELETE_INTERNSHIP_SUCCESS = "DELETE_INTERNSHIP_SUCCESS"
export const DELETE_INTERNSHIP_FAIL = "DELETE_INTERNSHIP_FAIL"





